import determineImgSrcFromList from './determineImgSrcFromList';
export default determineImgSrcFromList;
